export default {
  PUBLISHER: 'PUBLISHER',
  SALE: 'SALE',
};
